export default __webpack_public_path__ + "static/news1-27851f6921b417789f8c359db5c34775.png";